import React from "react"
import styled from "styled-components"
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { CheckboxListField } from "../../../designSystem/formField/CheckboxListField";
import { DateInputField } from "../../../designSystem/formField/DateInputField";
import { RadioButtonListField } from "../../../designSystem/formField/RadioButtonListField";
import { SelectField } from "../../../designSystem/formField/SelectField";
import { StaticTextField } from "../../../designSystem/formField/StaticTextField";
import { TextAreaSaveField } from "../../../designSystem/formField/textArea/TextAreaSaveField";
import { TextAreaField } from "../../../designSystem/formField/textArea/TextAreaField";
import { TimeInputField } from "../../../designSystem/formField/TimeInputField";
import { CheckboxOption } from "../../../designSystem/inputs/Checkbox";
import { RadioButtonOption } from "../../../designSystem/inputs/RadioButton";
import { H2 } from "../../../designSystem/typography/Heading";
import { TextSaveField } from "../../../designSystem/formField/text/TextSaveField";
import { TextField } from "../../../designSystem/formField/text/TextField";

export const FormFieldOverview = (): JSX.Element => 
{
    const [text, setText] = React.useState('');
    
    const [checkboxOptions, setCheckboxOptions] = React.useState<CheckboxOption[]>([
        { text:'Rød', value:'red', checked:false },
        { text:'Grøn', value:'green', checked:true},
        { text:'Blå', value:'blue', checked:true}
    ]);

    const radioButtonOptions:RadioButtonOption[] =[
        { text:'Rektangel', value:'rectangle' },
        { text:'Kvadrat', value:'square'},
        { text:'Rund', value:'round'}
    ];
    const [selectedRadioButtonValue, setSelectedRadioButtonValue] = React.useState('');

    const [selectedDateTime, setSelectedDateTime] = React.useState<Date|null>(new Date());


    function handleCancel()
    {
        alert('restoring value');
    }

    function handleSave(value:string)
    {
        alert('saving value:' + value);
        setText(value);
    }

    function validateValue(value:string): {valid:true} | {valid:false, errorMessage:string}
    {
        return value.length === 0 || text.length < 11 
            ? { valid:true } 
            : { valid:false, errorMessage:'Hov! Feltet må maks. indholde 10 tegn'}
    }

    return (
        <Flex flexDirection="column" gap={24}>
            
            <Flex flexDirection='row' justifyContent="stretch" gap={16}>

                <Flex flexDirection='column' gap={16} style={{flexGrow:'1'}}>
                    <H2>TextField</H2>
                    <TextField
                            label="Single line, uden info"
                            placeholder="Denne tekst skal udfyldes... g"
                            value={text}
                            onChange={value => setText(value)} 
                            validator={validateValue}
                    />
                    <TextField
                        label="Single line, alert ved !isValid"
                        placeholder="Denne tekst skal udfyldes..."
                        infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                        value={text}
                        onChange={(value, isValid) => { !isValid ? alert('hov') : setText(value)}} 
                        validator={validateValue}
                    />

                    <TextField
                        label="Single line, disabled"
                        placeholder="Denne tekst skal udfyldes..."
                        infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                        value={text}
                        disabled={true}
                        onChange={value => setText(value)} 
                        validator={validateValue}
                    />
                    <TextField
                        label="Single line, with icons"
                        placeholder="Denne tekst skal udfyldes..."
                        infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                        value={text}
                        leadingIcon={"navigation_home"}
                        trailingIcon={"navigation_home"}
                        onChange={value => setText(value)}
                        validator={validateValue}
                    />

                    <TextField
                        label="Single line, with icons, disabled"
                        placeholder="Denne tekst skal udfyldes..."
                        infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                        value={text}
                        leadingIcon={"navigation_home"}
                        trailingIcon={"navigation_home"}
                        onChange={value => setText(value)}
                        validator={validateValue}
                        disabled={true}
                    />
                </Flex>
            </Flex>

            <Flex flexDirection='row' justifyContent="stretch" gap={16}>
                <Flex flexDirection='column' gap={16} style={{flexGrow:'1'}}>
                    <H2>TextSaveField</H2>
                    <TextSaveField 
                        value={text} 
                        onSave={(value) => setText(value)} 
                        label={"Ingen dikkedarer"}
                        infoMessage="Her er en message" />
                    
                    <TextSaveField 
                        value={text} 
                        onSave={(value) => setText(value)} 
                        label={"Her som en ERROR!"}
                        errorMessage="Her er en message" />

                    <TextSaveField 
                        value={text} 
                        onSave={(value) => setText(value)} 
                        label={"Uden message"} />

                    <TextSaveField 
                        value={text} 
                        onSave={(value) => setText(value)} 
                        label={"Disabled"}
                        disabled={true} />
                </Flex>
                
                <Flex flexDirection='column' gap={16} style={{flexGrow:'1'}}>
                    <H2>TextSaveField</H2>
                    <TextSaveField
                        label="Single line with save, validates typed field"
                        placeholder="Denne tekst skal udfyldes..."
                        infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                        value={text}
                        onCancel={handleCancel}
                        onSave={handleSave}
                        validator={(currentValue) => 
                            currentValue.length === 0 || currentValue.length < 11 
                                ? { valid:true } 
                                : { valid:false, errorMessage:'Hov! Feltet må maks. indholde 10 tegn'}
                        }
                    />
                    <TextSaveField
                        label="Single line with save, validates saved field"
                        placeholder="Denne tekst skal udfyldes..."
                        infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                        value={text}
                        onCancel={handleCancel}
                        onSave={handleSave}
                        validator={(originalValue) => 
                            originalValue.length === 0 || originalValue.length < 11 
                                ? { valid:true } 
                                : { valid:false, errorMessage:'Hov! Feltet må maks. indholde 10 tegn'}
                        }
                    />
                    <TextSaveField
                        label="Single line with save, validates saved field, disabled"
                        placeholder="Denne tekst skal udfyldes..."
                        infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                        value={text}
                        onCancel={handleCancel}
                        onSave={handleSave}
                        validator={(originalValue) => 
                            originalValue.length === 0 || originalValue.length < 11 
                                ? { valid:true } 
                                : { valid:false, errorMessage:'Hov! Feltet må maks. indholde 10 tegn'}
                        }
                        disabled={true}
                    />
            </Flex>
        </Flex>

        <Flex flexDirection='row' justifyContent="stretch" gap={16}>

            <Flex flexDirection='column' gap={16} style={{flexGrow:'1'}}>
                <H2>TextAreaField</H2>
                <TextAreaField
                    label="Multiline, uden info"
                    placeholder="Denne tekst skal udfyldes..."
                    value={text}
                    onChange={value => setText(value)} 
                    validator={validateValue}
                />
                <TextAreaField
                    label="Multiline, alert ved !isValid"
                    placeholder="Denne tekst skal udfyldes..."
                    value={text}
                    onChange={(value, isValid) => { !isValid ? alert('hov') : setText(value)}} 
                    validator={validateValue}
                />
                <TextAreaField
                    label="Multiline"
                    placeholder="Denne tekst skal udfyldes..."
                    infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                    value={text}
                    onChange={value => setText(value)} 
                    validator={validateValue}
                />
                <TextAreaField
                    label="Multiline, disabled"
                    placeholder="Denne tekst skal udfyldes..."
                    infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                    disabled={true}
                    value={text}
                    onChange={value => setText(value)} 
                    validator={validateValue}
                />
                <TextAreaField
                    label="Multiline, minrows(4)"
                    placeholder="Denne tekst skal udfyldes..."
                    infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                    value={text}
                    minRows={4}
                    onChange={value => setText(value)} 
                    validator={validateValue}
                />
                <TextAreaField
                    label="Multiline, minrows(4), disabled"
                    placeholder="Denne tekst skal udfyldes..."
                    infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                    value={text}
                    minRows={4}
                    onChange={value => setText(value)} 
                    validator={validateValue}
                    disabled={true}
                />
            </Flex>
        </Flex>
        
        <Flex flexDirection='row' justifyContent="stretch" gap={16}>
            <Flex flexDirection='column' gap={16} style={{flexGrow:'1'}}>
                <H2>TextAreaSaveField</H2>
                <TextAreaSaveField
                    label="Multiline line with save, validates typed field"
                    placeholder="Denne tekst skal udfyldes..."
                    infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                    value={text}
                    onCancel={handleCancel}
                    onSave={handleSave}
                    validator={(currentValue) => 
                        currentValue.length === 0 || currentValue.length < 11 
                            ? { valid:true } 
                            : { valid:false, errorMessage:'Hov! Feltet må maks. indholde 10 tegn'}
                    }
                />
                <TextAreaSaveField
                    label="Multiline line with save, validates saved field"
                    placeholder="Denne tekst skal udfyldes..."
                    infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                    value={text}
                    onCancel={handleCancel}
                    onSave={handleSave}
                    validator={(originalValue) => 
                        originalValue.length === 0 || originalValue.length < 11 
                            ? { valid:true } 
                            : { valid:false, errorMessage:'Hov! Feltet må maks. indholde 10 tegn'}
                    }
                />
                <TextAreaSaveField
                    label="Multiline line with save, validates saved field, disabled"
                    placeholder="Denne tekst skal udfyldes..."
                    infoMessage={`Denne tekst erstattes ved fejl. Der er nu ${text.length}/10 tegn`}
                    value={text}
                    onCancel={handleCancel}
                    onSave={handleSave}
                    validator={(originalValue) => 
                        originalValue.length === 0 || originalValue.length < 11 
                            ? { valid:true } 
                            : { valid:false, errorMessage:'Hov! Feltet må maks. indholde 10 tegn'}
                    }
                    disabled={true}
                />
            </Flex>
        </Flex>
            <h2>Selector FormFields</h2>
            <Container>
                <Row>
                    <div>
                        <CheckboxListField 
                            options={checkboxOptions}
                            onChange={(item, allItems)=>setCheckboxOptions(allItems)} 
                            label="Vælg en farve" />
                    </div>
                    <div>
                        <RadioButtonListField
                            groupName={"shapes"} 
                            options={radioButtonOptions}
                            onChange={(value) => setSelectedRadioButtonValue(value)}
                            label="Vælg en form" 
                            selectedValue={selectedRadioButtonValue} />
                    </div>
                    <div>
                        <SelectField
                            options={radioButtonOptions}
                            onChange={(value) => setSelectedRadioButtonValue(value)}
                            label="Vælg en form" 
                            selectedValue={selectedRadioButtonValue}
                            emptyText="..." />
                    </div>
                </Row>
            </Container>
            <h2>DateTime FormFields</h2>
            <Container>
                <Row>
                    <div>
                        <DateInputField 
                            value={selectedDateTime} 
                            onValueChange={(value) => setSelectedDateTime(value)} 
                            showClearButton={true}
                            label={"Vælg en dato efter 1/1/2023"} 
                            validator={(value: Date | null) => {
                                if(value===null) return { valid:false, errorMessage:'Vælg en dato'}
                                else if(value.getTime() < new Date(2023,1,1).getTime()) return { valid:false, errorMessage:'Ugyldig dato'}
                                else return {valid:true}
                            }} />
                    </div>
                    <div>
                        <TimeInputField 
                            value={selectedDateTime} 
                            onValueChange={(value) => setSelectedDateTime(value)} 
                            label={"Vælg et tidspunkt mellem 8 og 16"} 
                            validator={(value: Date | null) => {
                                if(value===null) return { valid:false, errorMessage:'Vælg et tidspunkt'}
                                else if(
                                    value.getHours() < 8 || (value.getHours() > 15 && value.getMinutes() > 0)) return { valid:false, errorMessage:'Ugyldig tidspunkt'}
                                else return {valid:true}
                            }} />
                    </div>
                </Row>
            </Container>
            <h2>StaticText FormField</h2>
            <Container>
                <Row>
                    <div>
                        <StaticTextField 
                            staticText="This is a short text" 
                            label={"Itsy bitsy text"} 
                        />
                    </div>
                    <div>
                        <StaticTextField
                            staticText="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus arcu libero, tristique a odio nec, pellentesque elementum ex. Ut porta non nunc in dictum. Nulla sed dictum sapien. Mauris id tempor lacus. Nulla blandit urna nec felis tincidunt, at fringilla odio tristique. Etiam sed neque odio. Integer vitae aliquam dui. Morbi non tincidunt arcu. Quisque dapibus semper consequat. Cras at dolor vitae mi viverra euismod a quis risus. Etiam nisl libero, hendrerit a convallis vel, porttitor id ex. Aliquam turpis eros, bibendum eget viverra vel, dapibus ut nunc. Sed sollicitudin sollicitudin mauris ac accumsan. Nam vehicula elit sit amet lorem efficitur iaculis. Nullam facilisis erat tellus, molestie luctus nisi eleifend sit amet."
                            label={"Lorep Ipsum"} />
                    </div>
                </Row>
            </Container>
        </Flex>
    );
}

const Container = styled.div`
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #888;
`;

const Row = styled.div`
    gap:20px;
    display: flex;
    flex-direction: row;
    align-items: top;

    & > * {
        flex: 1 1 0px;
    }
`;